export default status => {
  if (status === 'ACTIVE') {
    return '#C9FFEF';
  } if (status === 'SUCCEEDED') {
    return '#ececff';
  } return '#C9FFEF';
};
